import { useMentionCards } from "@/contexts/MentionCardsContext";
import { ShareIcon } from "@/Icons";
import Button, { ButtonProps } from "@components/Button";

import { useMentionCard } from "../../context";

const ShareEpisode = (props: ButtonProps) => {
  const { shareV4 } = useMentionCards();

  const episode = useMentionCard();
  const { hideActions } = episode;

  if (hideActions) {
    return null;
  }

  return (
    <Button
      block
      data-testid="share-mention"
      variant="tertiary"
      type="button"
      icon={ShareIcon}
      onClick={() => shareV4(episode)}
      {...props}
    >
      {L.MENTIONS_SHARE}
    </Button>
  );
};

export default ShareEpisode;
